//dependencias
import React, { Component } from 'react';

//componentes
import EstadisticaAction from './Estadistica'

class Estadistica extends Component {

    render(){
        return(
            <div>
                <EstadisticaAction />
            </div>
        );
    }

}
export default Estadistica;